import _ from 'underscore';

import { staticTemplateProperties } from '@bingads-webui-campaign-react/ad-placement-templates';

import { getLocalizedText, getPreviewTexts } from '../common/index';

const defaultPreviewTextKeys = {
  shortHeadline: _TL_('Title part 1'),
  longHeadline: _TL_('Title part 1 | Title part 2 | Title part 3'),
  description: _TL_('Ad text 1. Ad text 2'),
  businessName: _TL_('Business name'),
};

export const transformToTemplateData = ({
  adData,
  template,
  i18n,
}) => {
  const localizedText = getLocalizedText(template, i18n);
  const carryOverProperties = _.pick(template, staticTemplateProperties);
  const {
    previewSettings,
    imagePreviewHeight,
    styleOverrides,
  } = template;

  const defaultPreviewTexts = {
    ..._.mapObject(defaultPreviewTextKeys, stringKey => i18n.getString(stringKey)),
  };
  const skipUrlValidation = previewSettings.showUrlMultiline;
  const previewTexts = getPreviewTexts({
    adData,
    skipUrlValidation,
    defaultPreviewTexts,
  });

  return {
    previewTexts,
    imagePreviewHeight,
    styleOverrides,
    ...previewSettings,
    ...localizedText,
    ...carryOverProperties,
  };
};
